import React, { useState, useEffect, createContext, useContext, useReducer } from 'react';
import { applyMiddleware } from 'context/middleware';
import reducer from 'context/reducers';
import { setUser, logOutUser, notification } from 'context/actions';
import User from 'services/user';

export const Context = createContext();

const combinedReducers = (state = {}, action = {}) => Object.assign({}, ...Object.keys(reducer).map(k => ({ [k]: reducer[k](state[k], action) })));

export default function Provider({ children }) {
  const [state, dispatch] = useReducer(combinedReducers, combinedReducers({}));
  const [loading, setLoading] = useState(!!state.user.token);

  useEffect(() => {
    if (state.user.token) {
      User.self()
        .then(({ data }) => {
          dispatch(setUser(data));
          setLoading(false);
        })
        .catch(({ message, error }) => {
          dispatch(logOutUser());
          dispatch(notification({ message: message || error, variant: 'error' }));
          setLoading(false);
        });
    }
  }, []);

  return (
    <Context.Provider value={[{ ...state, loading }, applyMiddleware(dispatch)]}>
      {children}
    </Context.Provider>
  )
}

export const useStore = () => useContext(Context);